import { render, staticRenderFns } from "./NewValidatedFormDemo.vue?vue&type=template&id=7a2ec524&"
import script from "./NewValidatedFormDemo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./NewValidatedFormDemo.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports